module.exports = {
  appName: process.env.REACT_APP_NAME || "tizen",
  // TODO Change localhost by the final location of the remote config
  configUrl: process.env.REACT_APP_REMOTE_CONFIG_URL || "http://localhost:3004/config",
  languageFilesUrl: process.env.REACT_APP_REMOTE_TRANSLATIONS_URL || "http://localhost:3004/translations",
  environment: process.env.NODE_ENV || "development"
};
